import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(() => ({
    msg: {
        padding: '8px 0',
        margin: 0,
    },
    msgFrom: {
        marginLeft: 2,
        fontWeight: 'bold',
        fontSize: 13,
        paddingRight: 8,
        textTransform: 'capitalize',
    },
    msgBody: {
        display: 'inline',
        paddingLeft: 10,
        wordBreak: 'break-word',
        hyphens: 'auto',
        textTransform: 'none',
    },
}))
